import React, { useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import fieldParams from '../../const/fieldParams';
import blackIcon from '../../assets/img/black-icon.png';
import wavIcon from '../../assets/img/wav-icon.png';
import taxiIcon from '../../assets/img/taxi-icon.png';

const RideTypeInput = ({ fieldKey }) => {
  const { key, label } = fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const {
    state: { defaultServiceType, step, serviceTypesAndAmounts },
    updateStep,
  } = context;

  const selectedType = serviceTypesAndAmounts[defaultServiceType];

  const getImageUrl = type => {
    if (!type?.image_url) return type === 'limo' ? blackIcon : type === 'wav' ? wavIcon : taxiIcon;

    return type.image_url;
  };

  const handleClick = () => {
    updateStep(step - 1);
  };

  return (
    <div className={`form-group form-group-${key}`}>
      <label htmlFor={key} className={`form-label${defaultServiceType === '' ? ' hidden' : ''}`}>
        {label}
      </label>
      <input
        name={key}
        id={key}
        type="text"
        className={`form-input ${key} ${defaultServiceType}`}
        defaultValue={selectedType?.display_name}
        onClick={handleClick}
      />
      <img
        src={getImageUrl(selectedType)}
        alt={`${defaultServiceType}`}
        className={`${defaultServiceType}-ride-type ride-type-field-image`}
      />
    </div>
  );
};

export default RideTypeInput;
